import Spinner from "../../../../components/Spinner.jsx";
import {useTranslation} from "react-i18next";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";
import FacebookLoginButton from "../../../../utils/brands/FacebookLoginButton.jsx";
import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import Select from "react-select";
import Button from "../../../../components/Button.jsx";
import useDownloadState from "../../../../api/utilities/useDownloadState.js";
import {ProjectIntegrationsApi} from "../../../../api/authority/generated/index";

export default function MetaIntegrationForm({project, projectIntegration}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let adAccountDefaultValues = [];
    let adAccountOptions = [];


    for (let adAccount of projectIntegration?.metaIntegrationAdAccounts ?? []) {
        adAccountOptions.push({
            value: adAccount.accountId,
            label: '[' + adAccount.accountId + '] ' + adAccount.name
        });

        if (adAccount.enabled) {
            adAccountDefaultValues.push({
                value: adAccount.accountId,
                label: '[' + adAccount.accountId + '] ' + adAccount.name
            });
        }
    }

    let [selectedAdAccounts, setSelectedAdAccounts] = useState(adAccountDefaultValues);

    const {context, getAuthorityConfiguration, resetCurrentUserProjects} = useContext(GlobalContext);

    let redirectToLogin = () => {
        let oAuthUrl = new URL(import.meta.env.VITE_AUTHORITY_URL);
        oAuthUrl.pathname = '/api/v1/project/integrations/meta';

        let query = new URLSearchParams({
            authorization: context.currentIdentity?.token,
            projectId: project.id,
        });

        if (projectIntegration?.id) {
            query.set('integrationId', projectIntegration.id);
        }

        oAuthUrl.search = query.toString();

        window.location.href = oAuthUrl.toString();
    };

    useEffect(() => {
        if (!projectIntegration) {
            setTimeout(
                () => redirectToLogin(),
                100,
            )
        }
    }, []);

    let [state, setDownloading] = useDownloadState();

    let saveAdAccounts = () => {
        let adAccountIds = [];

        for (let adAccountOption of selectedAdAccounts) {
            adAccountIds.push(adAccountOption.value);
        }

        setDownloading(true);
        new ProjectIntegrationsApi(getAuthorityConfiguration())
            .chooseMetaAdAccounts({
                projectId: project.id,
                integrationId: projectIntegration.id,
                requestBody: adAccountIds
            })
            .then(() => {
                resetCurrentUserProjects();
            })
            .finally(() => setDownloading(false))
    };

    if (!projectIntegration) {
        return (
            <div>
                <Spinner size={'spinner-large'} className={'mx-auto'}/>
                <p className={'text-center mt-4'}>{t('redirecting')}...</p>
            </div>
        );
    }

    return (<div className={'flex flex-col gap-4'}>
        <div className={'flex gap-6 justify-start items-center'}>
            <div className={'w-3/12 text-right'}>{t('project.meta.re-authorize')}:</div>
            <div className={'w-36'}>
                <FacebookLoginButton
                    configurationId={import.meta.env.VITE_META_CONNECT_CONFIGURATION_ID}
                    onClick={() => redirectToLogin()}
                    config={{
                        response_type: 'code',
                        override_default_response_type: true,
                        scope: 'ads_read,business_management'
                    }}
                >
                    {t('project.integration-connect-button')}
                </FacebookLoginButton>
            </div>
        </div>

        <div className={'flex gap-6 justify-start items-center'}>
            <div className={'w-3/12 text-right'}>{t('project.meta.access-token')}:</div>
            <div className={'w-9/12 italic'}>{projectIntegration.accessToken}</div>
        </div>

        <div className={'text-2xl text-slate-800 dark:text-white mt-6'}>{t('project.ad-accounts')}</div>

        <div className={'w-10/12 mx-auto'}>
            <Select
                defaultValue={adAccountDefaultValues}
                isMulti
                name="colors"
                options={adAccountOptions}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={setSelectedAdAccounts}
            />
        </div>

        <div className={'w-10/12 mx-auto text-right'}>
            <Button
                className={'button-primary'}
                onClick={() => saveAdAccounts()}
            >
                {t('project.meta.save-ad-accounts')}
            </Button>
        </div>

        {/*projectIntegration.metaIntegrationAdAccounts.map((metaIntegrationAdAccount) => {
            return (<div key={metaIntegrationAdAccount.accountId}>
                    <div className={'flex gap-6 justify-start items-center my-3'}>
                        <div className={'w-3/12 text-right'}>{t('project.ad-account')}:</div>
                        <div className={'w-9/12 italic'}>{metaIntegrationAdAccount.name}</div>
                    </div>
                    <div className={'flex gap-6 justify-start items-center my-3'}>
                        <div className={'w-3/12 text-right'}>{t('timezone')}:</div>
                        <div className={'w-9/12 italic'}>{metaIntegrationAdAccount.timeZone}</div>
                    </div>
                    <div className={'flex gap-6 justify-start items-center my-3'}>
                        <div className={'w-3/12 text-right'}>{t('currency')}:</div>
                        <div className={'w-9/12 italic'}>{metaIntegrationAdAccount.currency}</div>
                    </div>
                </div>
            );
        })*/}


    </div>);
}
